import { ApolloClient, InMemoryCache, ApolloLink } from '@apollo/client';
import { RestLink } from 'apollo-link-rest';

// Set `RestLink` with your endpoint
const restLink = new RestLink({
  uri: process.env.NODE_ENV !== 'production' ? `http://${window.location.hostname}:6002/v1/` : '/v1/',
  customFetch: async (requestUrl, requestParams) => {
    const response = await fetch(requestUrl, requestParams);
    if (response.status === 404) {
      const err = new Error('Not Found');
      err.statusCode = 404;
      err.result = await response.json();
      throw err;
    }
    return response;
  },
});

// Setup your client
const client = new ApolloClient({
  cache: new InMemoryCache(),
  // link: ApolloLink.from([authLink, restLink]),
  link: ApolloLink.from([restLink]),
});

export default client;
